exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.icon[data-v-274cb798] {\n    flex: 0 0 1.25rem;\n    font-size: 0;\n}\n.icon img[data-v-274cb798] {\n    max-width: 100%;\n    max-height: 100%;\n    width: 100%;\n}\n", ""]);

// exports
